import feedbackActionTypes from './feedback.types';
const INITIAL_STATE = {
  loading: false,
  success: undefined,
  error: undefined,
};
const feedbackReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case feedbackActionTypes.FEEDBACK_SITE_START:
      return {
        loading: true,
        success: undefined,
        error: undefined,
      };
    case feedbackActionTypes.CLEAR_MESSAGE:
      return {
        ...state,
        success: undefined,
        error: undefined,
      };
    case feedbackActionTypes.FEEDBACK_SITE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: 'Đăng ký nhận thông báo thành công.',
      };
    case feedbackActionTypes.FEEDBACK_SITE_FAIL:
      return {
        ...state,
        loading: false,
        error: `Đăng ký nhận thông báo không thành công, có lỗi xảy ra. ${action.payload}`,
      };
    default:
      return state;
  }
};

export default feedbackReducer;
